// src/components/Badge.jsx
import React from "react";

const tones = {
  success: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
  warn:    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300",
  danger:  "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-400",
  neutral: "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200",
};

export default function Badge({ children, tone = "neutral", title }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-semibold ${tones[tone]}`} title={title}>
      {children}
    </span>
  );
}